"use strict";
/**
 * Created by Ning Jiang on 12/3/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NearWinReelDivider = void 0;
const gsap_1 = require("gsap");
const EventHandler_1 = require("../../core/event/EventHandler");
const GameConfig_1 = require("../../core/gameconfig/GameConfig");
const ReelEvent_1 = require("../../core/reel/event/ReelEvent");
const SpinEvent_1 = require("../../core/spin/event/SpinEvent");
const StageManager_1 = require("../../core/stage/StageManager");
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const SpinReelEvent_1 = require("../reel/spinreel/SpinReelEvent");
const StaticReelDivider_1 = require("./StaticReelDivider");
const SlotGame_1 = require("../../core/SlotGame");
const TimelineSprite_1 = require("../../core/animation/TimelineSprite");
class NearWinReelDivider extends StaticReelDivider_1.StaticReelDivider {
    constructor(config) {
        super(config);
        this._nearWinTexturesGetter = config.nearWinTexturesGetter;
        this._reelIndexMap = config.reelIndexMap;
        this._nearWinSounds = config.nearWinSounds;
        this._nearWinBlendMode = config.nearWinBlendMode;
        this._nearWinContainer = new PIXI.Container();
        this._nearWinLayer = StageManager_1.StageManager.getLayer(config.layer);
        this._nearWinLayer.addChild(this._nearWinContainer);
    }
    addEventListeners() {
        EventHandler_1.EventHandler.addEventListener(this, SpinEvent_1.SpinEvent.BEFORE_START, (event) => this.onSpinStart());
        EventHandler_1.EventHandler.addEventListener(this, ReelEvent_1.ReelEvent.REEL_STOP_SPIN_ANIMATION_COMPLETE, (event) => this.onReelSpinAnimationComplete(event.params[0]));
        if (GameConfig_1.GameConfig.instance.SPIN_MODE === 1 /* SpinMode.AVALANCHE */) {
            // TODO:
        }
        else {
            EventHandler_1.EventHandler.addEventListener(this, SpinReelEvent_1.SpinReelEvent.REEL_ON_NEAR_WIN, (event) => this.onPlayReelNearWinAttention(event.params[0]));
        }
    }
    ;
    initAnimations() {
        super.initAnimations();
        this._nearWinDividers = [];
        this._nearWinDivAnimations = [];
        for (let i = 0; i < this._positions.length; i++) {
            const divider = this.createNearWinDivider(i);
            this._nearWinDividers.push(divider);
            this._nearWinDivAnimations.push(null);
            if (divider) {
                divider.x = this._positions[i][0];
                divider.y = this._positions[i][1];
                divider.alpha = 0;
                if (this._nearWinBlendMode != undefined) {
                    divider.blendMode = this._nearWinBlendMode;
                }
                this._nearWinContainer.addChild(divider);
            }
        }
    }
    createNearWinDivider(index) {
        const textures = this._nearWinTexturesGetter(index);
        if (textures == null) {
            Logger_1.Logger.logDev(`NearWinReelDivider.createNearWinDivider(): divider ${index} is missing image config, skip it!`);
            return null;
        }
        const sprite = new TimelineSprite_1.TimelineSprite(textures);
        sprite.anchor.x = 0.5;
        return sprite;
    }
    onSpinStart() {
        this._activeReelId = -1;
    }
    clearAnimation(activeIndex) {
        const tl = this._nearWinDivAnimations[activeIndex];
        if (tl) {
            if (tl.isActive()) {
                tl.pause();
            }
            tl.kill();
            this._nearWinDivAnimations[activeIndex] = null;
        }
    }
    onPlayReelNearWinAttention(reelId) {
        this._activeReelId = reelId;
        const activeDividerIndexes = this._reelIndexMap[this._activeReelId];
        for (let i = 0; i < activeDividerIndexes.length; i++) {
            const activeIndex = activeDividerIndexes[i];
            if (this._nearWinDividers[activeIndex]) {
                this.clearAnimation(activeIndex);
                const tl = new gsap_1.TimelineLite();
                tl.add(this.getDividerAnimation(this._nearWinDividers[activeIndex]), 0);
                this._nearWinDivAnimations[activeIndex] = tl;
            }
        }
        this.playNearWinSound(reelId);
    }
    // To override for different animations.
    getDividerAnimation(divider) {
        const timeline = new gsap_1.TimelineLite();
        timeline.add(new gsap_1.TweenLite(divider, 0.1, { alpha: 1 }), 0);
        timeline.add(divider.getAnimation(), 0);
        return timeline;
    }
    // To override for different animations.
    getDividerEndAnimation(divider) {
        const timeline = new gsap_1.TimelineLite();
        timeline.add(new gsap_1.TweenLite(divider, 0.2, { alpha: 0 }));
        return timeline;
    }
    playNearWinSound(reelId) {
        if (this._nearWinSounds && this._nearWinSounds[reelId]) {
            SlotGame_1.SlotGame.sound.playEffect(this._nearWinSounds[reelId]);
        }
    }
    onReelSpinAnimationComplete(stopData) {
        if (stopData.reelId != this._activeReelId) {
            return;
        }
        const activeDividerIndexes = this._reelIndexMap[this._activeReelId];
        for (let i = 0; i < activeDividerIndexes.length; i++) {
            const activeIndex = activeDividerIndexes[i];
            if (this._nearWinDividers[activeIndex]) {
                this.clearAnimation(activeIndex);
                const tl = new gsap_1.TimelineLite();
                tl.add(this.getDividerEndAnimation(this._nearWinDividers[activeIndex]), 0);
                tl.add(() => this.clearAnimation(activeIndex));
                this._nearWinDivAnimations[activeIndex] = tl;
            }
        }
        this.stopNearWinSound(stopData);
    }
    stopNearWinSound(stopData) {
        if (this._nearWinSounds && this._nearWinSounds[stopData.reelId]) {
            SlotGame_1.SlotGame.sound.stopEffect(this._nearWinSounds[stopData.reelId]);
        }
    }
}
exports.NearWinReelDivider = NearWinReelDivider;
//# sourceMappingURL=NearWinReelDivider.js.map